export default "__VITE_ASSET__DHwT_lKM__"